import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouteParams } from '../../../core/models/RouteParams';
import ProjectItemsOverviewTable from './ProjectItemsOverviewTable';

interface OwnProps {
}

export type Props = OwnProps & RouteComponentProps<RouteParams>;

export default withRouter(ProjectItemsOverviewTable);